const leadDetails = {
  attributesIgnore: [
    'name',
    'phone',
    'age',
    'tabulation',
    'channel',
    'note_internal',
    'cpf',
    'cpf_additional_1',
    'cpf_additional_2',
    'cpf_additional_3',
    'cpf_additional_4',
    'cpf_additional_5',
    'cpf_additional_6',
    'tabulated_cpf'
  ]
}

const state = {
  mainApi: process.env.VUE_APP_ROOT_API || '',
  isLoading: false,
  pageFilter: {
    name: '',
    email: '',
    phone: '',
    cpf: '',
    dateRange: '',
    action: '',
    plugin: '',
    product: '',
    status: '',
    csat: [],
    feeling: []
  },
  isPageFilterExceptionCsat: false,
  isPageFilterExceptionFeeling: false,
  isPageFilterExceptionStatus: false,
  showPageFilterBar: false,
  leadStatus: [
    {
      id: 4,
      label: 'Atendimento'
    },
    {
      id: 15,
      label: 'Agendamento'
    },
    {
      id: 3,
      label: 'Conversão'
    },
    {
      id: 16,
      label: 'Recusa'
    }
  ],
  platformActions: [],
  platformPlugins: [],
  platformAttributes: [],
  isLoadingPlatformPlugins: false,
  platforms: [
    {
      id: 705,
      colorPrimary: '#172542',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 612,
      colorPrimary: '#c81a78',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 609,
      colorPrimary: '#04e7d3',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 610,
      colorPrimary: '#000000',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 613,
      colorPrimary: '#cc6e24',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 605,
      colorPrimary: '#ff6039',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 3,
      colorPrimary: '#ff8956',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 615,
      colorPrimary: '#2eaaba',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 602,
      colorPrimary: '#009bbf',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 616,
      colorPrimary: '#182e3f',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 617,
      colorPrimary: '#ff007b',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 618,
      colorPrimary: '#0055f1',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 619,
      colorPrimary: '#ffee19',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 620,
      colorPrimary: '#1f8693',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 621,
      colorPrimary: '#ff6910',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 622,
      colorPrimary: '#3b3b3b',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 625,
      colorPrimary: '#003f57',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 627,
      colorPrimary: '#9b111e',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 628,
      colorPrimary: '#000000',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 629,
      colorPrimary: '#e9c3b0',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 630,
      colorPrimary: '#4e306e',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 631,
      colorPrimary: '#086568',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 632,
      colorPrimary: '#00463c',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 633,
      colorPrimary: '#3d8c4c',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 635,
      colorPrimary: '#22773b',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 636,
      colorPrimary: '#7a6c54',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 645,
      colorPrimary: '#000000',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 644,
      colorPrimary: '#0c3723',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 646,
      colorPrimary: '#034168',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 647,
      colorPrimary: '#334a7c',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 650,
      colorPrimary: '#02933f',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 649,
      colorPrimary: '#1e2a54',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 651,
      colorPrimary: '#7668ac',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 652,
      colorPrimary: '#f28c2a',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 655,
      colorPrimary: '#c22629',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 657,
      colorPrimary: '#00e88f',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 658,
      colorPrimary: '#cd1719',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 659,
      colorPrimary: '#28388f',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 660,
      colorPrimary: '#fa6300',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 662,
      colorPrimary: '#343434',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 665,
      colorPrimary: '#e30609',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 667,
      colorPrimary: '#00c5ff',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 648,
      colorPrimary: '#c81a78',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 668,
      colorPrimary: '#000000',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 671,
      colorPrimary: '#1b234a',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 672,
      colorPrimary: '#0a83a0',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 614,
      colorPrimary: '#1001f5',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 669,
      colorPrimary: '#3c3c3c',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 670,
      colorPrimary: '#c0beb5',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 676,
      colorPrimary: '#4671dd',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 673,
      colorPrimary: '#0074bb',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 673,
      colorPrimary: '#0074bb',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 677,
      colorPrimary: '#000e2b',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 678,
      colorPrimary: '#f37248',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 661,
      colorPrimary: '#6906b7',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 679,
      colorPrimary: '#04397b',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 684,
      colorPrimary: '#142364',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 685,
      colorPrimary: '#6906b7',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 708,
      colorPrimary: '#ff151e',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 711,
      colorPrimary: '#0052cc',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 683,
      colorPrimary: '#4e008e',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 706,
      colorPrimary: '#334acd',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 714,
      colorPrimary: '#00a0ff',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 638,
      colorPrimary: '#0027f4',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 656,
      colorPrimary: '#0f92ff',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 686,
      colorPrimary: '#03a9f4',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 687,
      colorPrimary: '#ffb000',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 688,
      colorPrimary: '#c81a78',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 689,
      colorPrimary: '#0ada52',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 694,
      colorPrimary: '#4b73da',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 698,
      colorPrimary: '#4b73da',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 699,
      colorPrimary: '#0b48fe',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 700,
      colorPrimary: '#4e2096',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 703,
      colorPrimary: '#0a52f8',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 704,
      colorPrimary: '#d2541f',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 707,
      colorPrimary: '#8cad34',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 709,
      colorPrimary: '#660099',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 713,
      colorPrimary: '#0052cc',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 715,
      colorPrimary: '#34d399',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 717,
      colorPrimary: '#0027f4',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 718,
      colorPrimary: '#ffd400',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 720,
      colorPrimary: '#4b73da',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 721,
      colorPrimary: '#ec0000',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 722,
      colorPrimary: '#ed0059',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 725,
      colorPrimary: '#0f92ff',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 727,
      colorPrimary: '#e62936',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 728,
      colorPrimary: '#e40d5b',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 729,
      colorPrimary: '#1fad2f',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 732,
      colorPrimary: '#0e6209',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 731,
      colorPrimary: '#4b73da',
      leadDetails: {
        attributesIgnore: [
          'email',
          'address',
          'marital_status',
          'home_phone',
          'phone3',
          'cpf',
          'limit',
          'birth_date',
          'age'
        ]
      }
    },
    {
      id: 730,
      colorPrimary: '#fed800',
      leadDetails: {
        attributesIgnore: [
          ...leadDetails.attributesIgnore
        ]
      }
    },
    {
      id: 820,
      colorPrimary: '#1e1e1e',
      leadDetails: {
        attributesIgnore: []
      }
    }
  ]
}

export default state
